import { CheckCircle2, Clock3, LoaderCircle, XCircle } from 'lucide-react';

const labels = {
  pending: 'В очереди',
  processing: 'Выполняется',
  completed: 'Завершён',
  failed: 'Ошибка',
  cancelled: 'Отменён'
};

export default function StatusBadge({ status }: { status: keyof typeof labels }) {
  const Icon = status === 'completed' ? CheckCircle2 : status === 'processing' ? LoaderCircle : status === 'pending' ? Clock3 : XCircle;
  return <span className={`status-badge status-${status}`}><Icon size={13} />{labels[status]}</span>;
}
